const DeleteIcon = (props:any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 34 34"
      {...props}
    >
      <g
        id="Group_94061"
        data-name="Group 94061"
        transform="translate(-6035 -872)"
      >
        <path
          id="Union_8"
          data-name="Union 8"
          d="M-4629.552,118a4.447,4.447,0,0,1-4.447-4.447v-25.1A4.448,4.448,0,0,1-4629.552,84h25.105A4.448,4.448,0,0,1-4600,88.448v25.1a4.448,4.448,0,0,1-4.449,4.447Z"
          transform="translate(10669 788)"
          fill="#0260fa"
        />
        <g
          id="Group_92541"
          data-name="Group 92541"
          transform="translate(0.116 -0.202)"
        >
          <path
            id="Subtraction_6"
            data-name="Subtraction 6"
            d="M-4626.629,111.8a1,1,0,0,1-.783-.391.98.98,0,0,1-.169-.857l1.221-4.554,4.545,4.545-4.553,1.222A1.007,1.007,0,0,1-4626.629,111.8Zm6.438-3.144h0l-4.523-4.523,13.451-13.451a1.623,1.623,0,0,1,1.156-.478,1.622,1.622,0,0,1,1.154.478l2.215,2.214a1.635,1.635,0,0,1,0,2.31l-13.452,13.45Z"
            transform="translate(10668.5 788)"
            fill="#fff"
            opacity="0"
          />
          <path
            id="garbage"
            d="M71.12,6.411H57.741c-.014.164-.063-.714.905,13.817A1.469,1.469,0,0,0,60.108,21.6h8.644a1.469,1.469,0,0,0,1.462-1.368C71.184,5.685,71.133,6.573,71.12,6.411Zm-9.33,12.483a.675.675,0,0,1-.731-.614l-.675-7.761a.675.675,0,0,1,1.345-.117l.675,7.761A.675.675,0,0,1,61.789,18.894Zm3.316-.672a.675.675,0,1,1-1.35,0V10.461a.675.675,0,1,1,1.35,0Zm3.372-7.7L67.8,18.281a.675.675,0,0,1-1.345-.117l.675-7.761a.675.675,0,1,1,1.345.117ZM71.4,2.362H68.137c.007-.089.005-.022.005-.9A1.468,1.468,0,0,0,66.676,0H62.184a1.468,1.468,0,0,0-1.466,1.466c0,.857,0,.807.005.9H57.46a1.468,1.468,0,0,0-1.466,1.466c0,1.206,0,1.148,0,1.234H72.862c.007-.087,0-.035,0-1.234A1.468,1.468,0,0,0,71.4,2.362Zm-4.608-.116a.116.116,0,0,1-.116.116H62.184a.116.116,0,0,1-.116-.116v-.78a.116.116,0,0,1,.116-.116h4.492a.116.116,0,0,1,.116.116Z"
            transform="translate(5987.07 878.202)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};
export default DeleteIcon;
